import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { amendmentsManager, type IAmendment } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { DEFAULT_KEY } from './constants';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IAmendmentAggregationByStatus } from './types';

const AMENDMENT_MODULE = 'amendment';

const state: IAmendmentAggregationByStatus = {
    aggregationByStatus: {
        [DEFAULT_KEY]: {
            totalCount: 0,
            byStatus: {}
        }
    }
};

const dataObjectModule = getDataObjectsModule<IAmendment>(amendmentsManager);
const searchModule = getSearchModule<IAmendment>(amendmentsManager);

const amendmentModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(AMENDMENT_MODULE, amendmentModuleInstance);

export { AMENDMENT_MODULE, DEFAULT_KEY };
